import { render } from "./FontSizeControl.vue?vue&type=template&id=bd30adb6"
import script from "./FontSizeControl.vue?vue&type=script&lang=js"
export * from "./FontSizeControl.vue?vue&type=script&lang=js"

import exportComponent from "/home/designwest/nailsea.place-deploy/nailsea.place/17052023_104622/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__